const MAX_JSON_BYTES = 1024 * 1024; // 1 MB
const MAX_QUERY_BYTES = 4 * 1024; // 4 KB
const MAX_FORMDATA_BYTES = 50 * 1024 * 1024; // 50 MB combined (matches backend upload limit)

const getUtf8Bytes = (value) => new TextEncoder().encode(value).length;

export const assertQueryWithinLimit = (url = "") => {
  if (!url || !url.includes("?")) return;
  const query = url.split("?")[1] || "";
  if (getUtf8Bytes(query) > MAX_QUERY_BYTES) {
    throw new Error("Query payload too large");
  }
};

export const assertPayloadWithinLimits = (data) => {
  if (data === undefined || data === null) return;

  if (typeof FormData !== "undefined" && data instanceof FormData) {
    let total = 0;
    for (const [, value] of data.entries()) {
      if (value instanceof File || value instanceof Blob) {
        total += value.size || 0;
      } else if (typeof value === "string") {
        total += getUtf8Bytes(value);
      }
      if (total > MAX_FORMDATA_BYTES) {
        throw new Error("Form payload too large");
      }
    }
    return;
  }

  if (typeof data === "object") {
    const json = JSON.stringify(data);
    if (getUtf8Bytes(json) > MAX_JSON_BYTES) {
      throw new Error("Request payload too large");
    }
  }
};

